module.exports = __webpack_public_path__ + "media/icons/public_marker_icon-8eb23649.png";